import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M10.483 17.629S.5 11 7.119 7.847c3.364-1.164 4.816 4.297 4.816 4.297s2.128-5.598 5.415-3.671c3.816 2.236-.828 6.598-2.395 8.08s-2.523 3.223-1.95 3.705 2.943 0 3.173.741"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M4 5s.764.333 1.261 1.037M19.261 5s-.764.333-1.261 1.037M10 3s.282.895.115 1.37M14.74 4.367c.05-.02.213-.746.864-1.252"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
  </svg>
);
export const HeartIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
